import React, { useState } from 'react'

// Material Ui
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import TabPanel from '../TabPanel/TabPanel'
import TextField from '@material-ui/core/TextField'

// Components
import Options from '../Options/Options'
import Ingredients from '../Ingredients/Ingredients'

// Translation
import { Language } from '../../Translation'

// Redux
import { connect } from 'react-redux'

const ItemPanels = ({ item, addOptions, addIngredients, setNotes, notes, clientData }) => {

    const [value, setValue] = useState(0)
    const { language } = clientData

    const addOptionsToTabPanel = () => {

        let options = []

        if (item.length !== 0) {
            options.push(
                <Options
                    key={item.UID}
                    item={item}
                    addOptions={addOptions}
                />
            )
        }

        return options
    }

    const addIngredientsToTabPanel = () => {

        let ingredients = []

        if (item.length !== 0) {
            item.Ingredient_List.map((ingredient, index) =>
                ingredients.push(
                    <Ingredients
                        key={ingredient}
                        uid={ingredient}
                        addIngredients={addIngredients}
                    />
                )
            )
        }
        return ingredients
    }

    const addNotesToTabPanel = () => {

        const styles = { width: "100%" }

        return (
            <TextField
                id="outlined-multiline-static"
                value={notes}
                label="Notes"
                style={styles}
                onChange={event => {
                    const { value } = event.target;
                    setNotes(value)
                }}
                multiline
                rows="12"
                placeholder="Notes about the item..."
                variant="outlined"
            />
        )
    }

    const addTabPanels = () => {

        let counter = 0
        let tabPanels = []

        if (item.Option_List.length !== 0) {
            tabPanels.push(
                <TabPanel
                    key={counter}
                    value={value}
                    index={counter} >
                    {addOptionsToTabPanel()}
                </TabPanel>
            )
            counter++
        }

        if (item.Ingredient_List.length !== 0) {
            tabPanels.push(
                <TabPanel
                    key={counter}
                    value={value}
                    index={counter} >
                    {addIngredientsToTabPanel()}
                </TabPanel>
            )
            counter++
        }

        tabPanels.push(
            <TabPanel
                key={counter}
                value={value}
                index={counter} >
                {addNotesToTabPanel()}
            </TabPanel>
        )

        return tabPanels
    }

    return (
        <>
            <AppBar position="sticky" color="default">
                <Tabs
                    value={value}
                    onChange={(event, value) => {
                        setValue(value)
                    }}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    scrollButtons="on"
                >
                    {item.Option_List.length !== 0 && <Tab label={Language.ItemOptions[language]} />}
                    {item.Ingredient_List.length !== 0 && <Tab label={Language.ItemIngredients[language]} />}
                    <Tab label={Language.ItemNotes[language]} />
                </Tabs>
            </AppBar>
            {addTabPanels()}
        </>
    )
}

const mapStateToProps = state => {
    return {
        clientData: state.clientData
    }
}

export default connect(mapStateToProps)(ItemPanels)